import { engineComponent } from "neo-common";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { ContainerElement } from "../../Components/Elements/Graphics/ContainerElement";
import { FreespinsController } from "./FreespinsController";
import { CreateFrameTimer, FrameTimerEventEmitter, FrameTimerEvents } from "../../Utils/FrameTimer";
import { Paylines } from "../Paylines";
import { PaylinesSelector } from "../PaylinesSelector";
import { Symbols } from "../Symbols";
import { Machine } from "../Machine";
import { WinAnimator } from "../WinAnimator";
import { WinAnimatorExtended } from "../../CustomComponents/WinAnimatorExtended";
import { StageController } from "../../Components/StageController";
import { SwitchElement } from "../../Components/Elements/Graphics/SwitchElement";
import { GameManager } from "../../Managers/GameManager";
import { Communication } from "neo-games";
import { DataManager } from "../../Managers/DataManager";
import { PlayList } from "../../Components/Sounds/PlayList";
import { HtmlController } from "../../HTMLComponents/HtmlController";
import { GameData } from "../../Channels/Common/Datas/GameData";
import { AmbientBackground } from "../../Utils/AmbientBackground";

@engineComponent(ComponentTypes.DisplayObject)
export class FreespinsView extends ContainerElement {
    private _controller: FreespinsController;

    private _introDelay: FrameTimerEventEmitter;
    private _outroDelay: FrameTimerEventEmitter;

    private _paylines: Paylines;
    private _paylinesSelector: PaylinesSelector;
    private _symbols: Symbols;
    private _machine: Machine;
    private _winAnimator: WinAnimatorExtended;
    private _noWinContainer: ContainerElement;
    private _winContainer: ContainerElement;

    private _fsMessageStart: HTMLElement;
    private _fsMessageEnd: HTMLElement;
    private _fsMessageEndNoWin: HTMLElement;

    private _teasing: SwitchElement;
    private _wildContainer: ContainerElement;
    private _transition: SwitchElement;

    constructor() {
        super();

        this._introDelay = CreateFrameTimer("introDelay");
        this._introDelay.on(FrameTimerEvents.Complete, this.introFinished.bind(this));

        this._outroDelay = CreateFrameTimer("outroDelay");
        this._outroDelay.on(FrameTimerEvents.Complete, this.outroFinished.bind(this));

        StageController.freespinsStageContainer = this;
    }

    create(node: Element): void {
        super.create(node);

        if (this.childs != null) {
            for (let key in this.childs) {
                if (this.childs[key] instanceof Paylines) {
                    this._paylines = this.childs[key];
                    this._paylines.reset();
                }

                if (this.childs[key] instanceof PaylinesSelector) {
                    this._paylinesSelector = this.childs[key];
                }

                if (this.childs[key] instanceof Symbols) {
                    this._symbols = this.childs[key];
                    this.removeChild(this._symbols);
                }

                if (this.childs[key] instanceof Machine) {
                    this._machine = this.childs[key];
                }

                if (this.childs[key] instanceof WinAnimator) {
                    this._winAnimator = this.childs[key];
                }

                if (key === "NoWinContainer" && this.childs[key] instanceof ContainerElement) {
                    this._noWinContainer = this.childs[key];
                }

                if (key === "WinContainer" && this.childs[key] instanceof ContainerElement) {
                    this._winContainer = this.childs[key];
                }

                if (key === "Teasing" && this.childs[key] instanceof SwitchElement) {
                    this._teasing = this.childs[key];
                }

                if (key === "WildContainer" && this.childs[key] instanceof ContainerElement) {
                    this._wildContainer = this.childs[key];
                }

                if (key === "Transition" && this.childs[key] instanceof SwitchElement) {
                    this._transition = this.childs[key];
                }
            }

            this._fsMessageStart = document.getElementById("fsMessageStart");
            this._fsMessageEnd = document.getElementById("fsMessageEnd");
            this._fsMessageEndNoWin = document.getElementById("fsMessageEndNoWin");

            if (DEBUG) {
                if (this._paylines == null) {
                    this.log("WARNING no paylines");
                }

                if (this._symbols == null) {
                    this.log("ERROR no symbols");
                }

                if (this._machine == null) {
                    this.log("ERROR no machine");
                }

                if (this._winAnimator == null) {
                    this.log("WARNING no winAnimator");
                }

                if (this._fsMessageStart == null) {
                    this.log("ERROR no fsMessageStart");
                }

                if (this._fsMessageEnd == null) {
                    this.log("ERROR no fsMessageEnd");
                }

                if (this._fsMessageEndNoWin == null) {
                    this.log("ERROR no fsMessageEndNoWin");
                }
            }
        }
    }

    disableLogo(): void {
        if (this.childs["Logo"] != null) {
            this.removeChild(this.childs["Logo"]);
        }
    }

    initReceived(controller: FreespinsController): void {
        if (DEBUG) {
            this.log("initReceived");
        }

        this._controller = controller;

        if (this._symbols != null) {
            if (this._machine != null) {
                if (GameManager.freespinsResponse != null) {
                    if (
                        GameManager.freespinsResponse.initData != null &&
                        GameManager.freespinsResponse.initData.reels !== null
                    ) {
                        this._machine.on(Machine.ReelStopped, this.onReelStopped.bind(this));
                        this._machine.on(Machine.MachineStopped, this.machineStopped.bind(this));
                        this._machine.inFreeSpins = true;
                        this._machine.initialize(
                            this._symbols,
                            GameManager.freespinsResponse.initData.reels,
                            this._teasing,
                        );
                    }

                    if (this._winAnimator != null) {
                        this._winAnimator.on(WinAnimator.FinishWinCalculation, this.finishWinCalculation.bind(this));
                        this._winAnimator.on(WinAnimator.FinishWinAnimator, this.finishWinAnimator.bind(this));
                        this._winAnimator.on(
                            WinAnimator.FinishQuickWinCalculation,
                            this.finishQuickWinCalculation.bind(this),
                        );
                        this._winAnimator.inFreeSpins = true;
                        this._winAnimator.initialize(
                            this._symbols,
                            this._paylines,
                            this._noWinContainer,
                            this._winContainer,
                        );
                        this._winAnimator.addElementInstance({ wildContainer: this._wildContainer });
                    }
                } else {
                    if (DEBUG) {
                        this.log("ERROR no freespin reponse");
                    }
                }
            } else {
                if (DEBUG) {
                    this.log("ERROR no machine");
                }
            }
        } else {
            if (DEBUG) {
                this.log("ERROR no symbols");
            }
        }

        this.visible = false;
    }

    initIntro(): void {
        StageController.baseStage = false;
        StageController.freespinStage = true;

        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.showSymbols(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.showInitWins(GameManager.freespinsResponse.wins, GameManager.freespinsResponse.currentWin);

        this.visible = true;

        this.childs["FS_Background"].goToCase("LOOP");
        this.childs["FS_Sky"].goToCase("LOOP");

        this.showMultipliers();
        this.addWinToMultipliers();
        this.selectMultiplier(true);

        this.retrigger();

        AmbientBackground.changeAmbientBackground("fs", 0);

        if (this.isLastFreespin()) {
            PlayList.stop("SND_FSLoop");
            PlayList.loop("SND_BaseLoop");
            PlayList.play("SND_FSEnd");

            if (GameManager.freespinsResponse.totalWin > 0) {
                if (this._fsMessageEnd != null && this._fsMessageEnd.classList.contains(HtmlController.DisabledClass)) {
                    this._fsMessageEnd.classList.remove(HtmlController.DisabledClass);
                }
            } else {
                if (
                    this._fsMessageEndNoWin != null &&
                    this._fsMessageEndNoWin.classList.contains(HtmlController.DisabledClass)
                ) {
                    this._fsMessageEndNoWin.classList.remove(HtmlController.DisabledClass);
                }
            }
        } else {
            PlayList.loop("SND_FSLoop");
        }
    }

    spin(): void {
        if (GameManager.freespinsResponse.wins.length > 0) {
            DataManager.updateGameDataFromModule(GameData.DataFreeSpinsMultiplierLevel, "2");
            DataManager.updateGameDataFromModule(GameData.DataFreeSpinsMultiplierIncreased, "false");
        }

        this.removeWinFromMultipliers();
        this.selectMultiplier(false);

        StageController.baseStage = false;
        StageController.freespinStage = true;

        PlayList.loop("SND_FSLoop");

        if (this._fsMessageStart != null && !this._fsMessageStart.classList.contains(HtmlController.DisabledClass)) {
            this._fsMessageStart.classList.add(HtmlController.DisabledClass);
        }

        if (this._paylinesSelector != null) {
            this._paylinesSelector.reset();
        }

        this._machine.spinStart(this._winAnimator.reset(false, true));
    }

    stop(): void {
        this._machine.spinStop(null, true);
    }

    startReceived(): void {
        if (this._fsMessageStart != null && !this._fsMessageStart.classList.contains(HtmlController.DisabledClass)) {
            this._fsMessageStart.classList.add(HtmlController.DisabledClass);
        }

        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.showSymbols(GameManager.freespinsResponse.screen.reels);
    }

    spinReceived(): void {
        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._machine.spinStop(null, false, true);
    }

    endReceived(): void {}

    onReelStopped(): void {
        this._winAnimator.onReelStopped(GameManager.freespinsResponse.screen.reels, this._machine.actualReelStopped);
    }

    machineStopped(): void {
        this._controller.machineStopped();

        if (DataManager.getDataById(GameData.DataFreeSpinsMultiplierIncreased) === "true") {
            this.selectMultiplier(true);

            setTimeout((): void => {
                this.machineStoppedContinued();
            }, 2000);
        } else {
            this.machineStoppedContinued();
        }
    }

    private machineStoppedContinued(): void {
        this.addWinToMultipliers();

        if (this._winAnimator.showWins(GameManager.freespinsResponse.wins, GameManager.freespinsResponse.currentWin)) {
            PlayList.stop("SND_FSLoop");
        }

        if (GameManager.freespinsResponse.wins != null && GameManager.freespinsResponse.wins.length > 0) {
            this._machine.removeTeasing(false);
        } else {
            this._machine.removeTeasing(true);
            this._winAnimator.removeTeasingFromScatters(11);
        }

        if (GameManager.freespinsResponse.currentWin === 0) {
            if (this.isLastFreespin()) {
                PlayList.stop("SND_FSLoop");
                PlayList.loop("SND_BaseLoop");
                PlayList.play("SND_FSEnd");

                if (GameManager.freespinsResponse.totalWin > 0) {
                    if (
                        this._fsMessageEnd != null &&
                        this._fsMessageEnd.classList.contains(HtmlController.DisabledClass)
                    ) {
                        this._fsMessageEnd.classList.remove(HtmlController.DisabledClass);
                    }
                } else {
                    if (
                        this._fsMessageEndNoWin != null &&
                        this._fsMessageEndNoWin.classList.contains(HtmlController.DisabledClass)
                    ) {
                        this._fsMessageEndNoWin.classList.remove(HtmlController.DisabledClass);
                    }
                }
            }
        }
    }

    private finishQuickWinCalculation(): void {
        this._controller.quickWinCalculationFinished();
    }

    finishWinCalculation(): void {
        this._controller.winCalculationFinished();
    }

    finishWinAnimator(): void {
        this._controller.allWinsFinished();

        if (this.isLastFreespin()) {
            PlayList.stop("SND_FSLoop");
            PlayList.loop("SND_BaseLoop");
            PlayList.play("SND_FSEnd");

            if (GameManager.freespinsResponse.totalWin > 0) {
                if (this._fsMessageEnd != null && this._fsMessageEnd.classList.contains(HtmlController.DisabledClass)) {
                    this._fsMessageEnd.classList.remove(HtmlController.DisabledClass);
                }
            } else {
                if (
                    this._fsMessageEndNoWin != null &&
                    this._fsMessageEndNoWin.classList.contains(HtmlController.DisabledClass)
                ) {
                    this._fsMessageEndNoWin.classList.remove(HtmlController.DisabledClass);
                }
            }
        } else {
            PlayList.loop("SND_FSLoop");
        }

        this.retrigger();
    }

    intro(long: boolean = false): void {
        StageController.freespinStage = true;

        this.visible = true;

        this.childs["FS_Background"].goToCase("LOOP");
        this.childs["FS_Sky"].goToCase("LOOP");

        if (this._transition != null) {
            AmbientBackground.changeAmbientBackground("fs", 500);
            this._transition.goToCase("FS_INTRO");
        }

        this.showMultipliers();
        this.selectMultiplier(false);

        this._introDelay.start(1);
    }

    introFinished(): void {
        StageController.baseStage = false;
        StageController.freespinStage = true;

        this.visible = true;

        PlayList.loop("SND_FSLoop");

        this._controller.introFinished();
    }

    outro(): void {
        StageController.freespinStage = true;

        this.visible = true;

        PlayList.stop("SND_FSLoop");
        PlayList.stop("SND_BaseLoop");
        PlayList.loop("SND_BaseRecapLoop");

        if (this._fsMessageEnd != null && !this._fsMessageEnd.classList.contains(HtmlController.DisabledClass)) {
            this._fsMessageEnd.classList.add(HtmlController.DisabledClass);
        }

        if (
            this._fsMessageEndNoWin != null &&
            !this._fsMessageEndNoWin.classList.contains(HtmlController.DisabledClass)
        ) {
            this._fsMessageEndNoWin.classList.add(HtmlController.DisabledClass);
        }

        if (this._paylinesSelector != null) {
            this._paylinesSelector.reset();
        }

        this._winAnimator.reset(true);

        if (this._transition != null) {
            this._transition.goToCase("FS_OUTRO");
            AmbientBackground.changeAmbientBackground("fsTransition", 500);
        }

        this.hideMultipliers();
        this.removeWinFromMultipliers();

        this._outroDelay.start(90);
    }

    outroFinished(): void {
        StageController.freespinStage = false;

        this.visible = false;

        this.childs["FS_Background"].goToCase("RESET");
        this.childs["FS_Sky"].goToCase("RESET");

        this._controller.outroFinished();
    }

    enable(): void {
        PlayList.play("SND_FSBoom");

        if (this._fsMessageStart != null && this._fsMessageStart.classList.contains(HtmlController.DisabledClass)) {
            this._fsMessageStart.classList.remove(HtmlController.DisabledClass);
        }
    }

    private retrigger(): void {
        if (!this.isLastFreespin()) {
            if (GameManager.freespinsResponse.wins != null && GameManager.freespinsResponse.wins.length > 0) {
                for (let i: number = 0; i < GameManager.freespinsResponse.wins.length; i++) {
                    if (GameManager.freespinsResponse.wins[i].type === Communication.Game.WinType.freeSpins) {
                        if (
                            this._fsMessageStart != null &&
                            this._fsMessageStart.classList.contains(HtmlController.DisabledClass)
                        ) {
                            this._fsMessageStart.classList.remove(HtmlController.DisabledClass);
                        }
                    }
                }
            }
        }
    }

    private isLastFreespin(): boolean {
        if (DataManager.GameLimit) {
            return true;
        }

        return (
            GameManager.freespinsResponse.freeSpins != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount === 0
        );
    }

    //******************************************************************************************************************
    //  MULTIPLIERS
    //******************************************************************************************************************

    private showMultipliers(): void {
        const holder = document.getElementById("fsMultiplierHolder");
        holder.classList.remove("_disabled");
    }

    private hideMultipliers(): void {
        const holder = document.getElementById("fsMultiplierHolder");
        holder.classList.add("_disabled");
    }

    private addWinToMultipliers(): void {
        if (GameManager.freespinsResponse.wins != null && GameManager.freespinsResponse.wins.length > 0) {
            const holder = document.getElementById("fsMultiplierHolder");
            holder.classList.add("winAnimation");
        }
    }

    private removeWinFromMultipliers(): void {
        const holder = document.getElementById("fsMultiplierHolder");
        holder.classList.remove("winAnimation");
    }

    private selectMultiplier(sounds: boolean): void {
        const multiplier = parseInt(DataManager.getDataById(GameData.DataFreeSpinsMultiplierLevel));
        const boxes = document.getElementsByClassName("fsMultiplier");

        for (let i = 0; i < boxes.length; i++) {
            const box = boxes[i];

            if (box.classList.contains("multi-x" + multiplier)) {
                if (sounds && multiplier > 2 && !box.classList.contains("_active")) {
                    setTimeout((): void => {
                        PlayList.play("SND_FSx" + multiplier);
                    }, 800);
                }

                box.classList.add("_active");
            } else {
                box.classList.remove("_active");
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Freespins/FreespinsView.ts
 **/